import { useCallback, useState } from "react";
import { useRouter } from "next/router";

import { apiFetch } from "~lib/apiFetch";

const useLogout = () => {
  const { locale } = useRouter();
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  const logout = useCallback(async () => {
    try {
      setIsLoggingOut(true);
      await apiFetch("/account/logout", {
        method: "POST",
        body: JSON.stringify({ locale }),
      });
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoggingOut(false);
    }
  }, [locale]);

  return { logout, isLoggingOut };
};

export default useLogout;
